import React from "react"
import KlaroConsentInfo from "./KlaroConsentInfo"

import useKlaroConsentable from "../../hooks/useKlaroConsentable"
import NexmartDealerMap from "./NexmartDealerMap"

const KLARO_GOOGLEMAPS_APP_KEY = "functional_widgets"

const NexmartDealerFinder = ({
  block,
  modalMode,
  modalModeScrollUpFunction,
}) => {
  const { usageConsented, appInfo, handleKlaroConsent } = useKlaroConsentable(
    KLARO_GOOGLEMAPS_APP_KEY
  )

  let appName = "Google Maps API"
  return (
    <>
      {usageConsented === false && appInfo ? (
        <div className="flex flex-row justify-center item-center">
          <div className="inline-block p-8">
            <KlaroConsentInfo
              appInfo={appInfo}
              appName={appName}
              handleKlaroConsent={handleKlaroConsent}
            />
          </div>
        </div>
      ) : (
        <NexmartDealerMap
          modalMode={modalMode}
          modalModeScrollUpFunction={() => modalModeScrollUpFunction()}
        />
      )}
    </>
  )
}

export default NexmartDealerFinder
